import './PlayNext.css';
import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import { PlayNextPreview } from '../PlayNextPreview';
import { PlayNextList } from '../PlayNextList';
import { useDeviceTypeHook } from '../../../../../../shared/src/hooks/use-device-type.hook';

export const PlayNext = () => {
    const { isMobile, isCoarsePointer } = useDeviceTypeHook();
    const [showGamesList, setShowGamesList] = useState(false);
    const hideTimeout = useRef(null);

    const clearHideTimeout = () => {
        if (hideTimeout.current) {
            clearTimeout(hideTimeout.current);
            hideTimeout.current = null;
        }
    };

    const openGamesList = () => {
        clearHideTimeout();
        setShowGamesList(true);
    };

    const closeGamesList = () => {
        if (isCoarsePointer) {
            setShowGamesList(false);
        } else if (hideTimeout.current == null) {
            hideTimeout.current = setTimeout(() => {
                setShowGamesList(false);
                clearHideTimeout();
            }, 500);
        }
    };

    let previewEvents = {
        onMouseEnter: openGamesList,
        onMouseLeave: closeGamesList,
    };

    if (isCoarsePointer) {
        previewEvents = {
            onClick: openGamesList,
        };
    }

    const wrapperClass = classNames(
        'game-page-header-play-next',
        {
            'game-page-header-play-next--desktop': !isMobile,
        }
    );

    return (
        <div className={wrapperClass}>
            {!showGamesList && <div
                className="game-page-header-play-next__preview"
                {...previewEvents}
            >
                <PlayNextPreview />
            </div>}

            {showGamesList && <>
                <PlayNextList
                    onCloseGamesList ={closeGamesList}
                    cancelScheduledClose={clearHideTimeout}
                />
                <div className="game-page-header-play-next-overlay"
                    onMouseEnter={closeGamesList}
                    onClick={closeGamesList}
                />
            </>}
        </div>
    );
};
